import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import kebabCase from 'lodash/kebabCase';
import { table, tableWithNestedTable } from '@atlaskit/adf-schema';
import { convertToInlineCss } from '@atlaskit/editor-common/lazy-node-view';
import { akEditorGutterPaddingDynamic } from '@atlaskit/editor-shared-styles';
import { generateColgroup, getResizerMinWidth } from '../pm-plugins/table-resizing/utils/colgroup';
import { TABLE_MAX_WIDTH } from '../pm-plugins/table-resizing/utils/consts';
import { getAlignmentStyle } from './table-container-styles';
export var tableNodeSpecWithFixedToDOM = function tableNodeSpecWithFixedToDOM(config) {
  var tableNode = config.isNestingSupported ? tableWithNestedTable : table;
  return _objectSpread(_objectSpread({}, tableNode), {}, {
    toDOM: function toDOM(node) {
      var gutterPadding = akEditorGutterPaddingDynamic() * 2;
      var alignmentStyle = Object.entries(getAlignmentStyle(node.attrs.layout)).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];
        return "".concat(kebabCase(k), ": ").concat(kebabCase(v));
      }).join(';');
      var tableMinWidth = getResizerMinWidth(node);
      var attrs = {
        'data-number-column': node.attrs.isNumberColumnEnabled,
        'data-layout': node.attrs.layout,
        'data-autosize': node.attrs.__autoSize,
        'data-table-local-id': node.attrs.localId,
        'data-table-width': node.attrs.width
      };
      var colgroup = '';
      if (config.allowColumnResizing) {
        colgroup = ['colgroup', {}].concat(_toConsumableArray(generateColgroup(node)));
      }
      var tableContainerDiv = ['div', {
        class: 'pm-table-container',
        'data-number-column': node.attrs.isNumberColumnEnabled,
        'data-layout': node.attrs.layout,
        'data-testid': 'table-container'
      }, ['div', {
        class: 'pm-table-sticky-sentinel-top',
        'data-testid': 'sticky-sentinel-top'
      }], ['div', {
        class: 'pm-table-row-controls-wrapper'
      }, ['div']], ['div', {
        class: 'pm-table-with-left-shadow',
        style: 'visibility: hidden'
      }], ['div', {
        class: 'pm-table-wrapper'
      }, ['table', attrs, ['span', {
        class: 'pm-table-shadow-sentinel-right'
      }], ['span', {
        class: 'pm-table-shadow-sentinel-left'
      }], colgroup, ['tbody', 0]]], ['div', {
        class: 'pm-table-with-right-shadow',
        style: 'visibility: hidden'
      }], ['div', {
        class: 'pm-table-sticky-sentinel-bottom',
        'data-testid': 'sticky-sentinel-bottom'
      }]];
      if (!config.tableResizingEnabled) {
        return ['div', {
          class: 'tableView-content-wrap',
          'data-prosemirror-initial-toDOM-render': 'true'
        }, tableContainerDiv];
      }
      var tableWidthAttribute = node.attrs.width ? "".concat(node.attrs.width, "px") : "100%";
      var tableResizingDiv = ['div', {
        'data-testid': 'table-alignment-container',
        style: alignmentStyle
      }, ['div', {
        class: 'pm-table-resizer-container',
        style: "width: min(calc(100cqw - ".concat(gutterPadding, "px), ").concat(tableWidthAttribute, ");")
      }, ['div', {
        class: 'resizer-item display-handle',
        style: convertToInlineCss({
          position: 'relative',
          userSelect: 'auto',
          boxSizing: 'border-box',
          '--ak-editor-table-gutter-padding': "".concat(gutterPadding, "px"),
          '--ak-editor-table-max-width': "".concat(TABLE_MAX_WIDTH, "px"),
          '--ak-editor-table-min-width': "".concat(tableMinWidth, "px"),
          minWidth: 'var(--ak-editor-table-min-width)',
          maxWidth: "min(calc(100cqw - var(--ak-editor-table-gutter-padding)), var(--ak-editor-table-max-width))",
          width: "min(calc(100cqw - var(--ak-editor-table-gutter-padding)), ".concat(tableWidthAttribute, ")")
        })
      }, ['span', {
        class: 'resizer-hover-zone'
      }, tableContainerDiv]]]];
      return ['div', {
        class: 'tableView-content-wrap',
        'data-prosemirror-initial-toDOM-render': 'true'
      }, tableResizingDiv];
    }
  });
};